// extracted by mini-css-extract-plugin
export default {"w-full":"Item_w-full__NLJzX","item":"Item_item__EKnHo","active":"Item_active__vQvFh","head":"Item_head__yUkt-","body":"Item_body__djzfj","category":"Item_category__RsOKm"};